import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansDetailPrepaymentsComponent from './loansDetailPrepayments.component';

let loansDetailPrepaymentsModule = angular.module('loansDetailPrepayments', [
  uiRouter
])

.component('loansDetailPrepayments', loansDetailPrepaymentsComponent)

.name;

export default loansDetailPrepaymentsModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailPrepayments/loansDetailPrepayments.js